<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="4"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>
    <div class="wrapper">
      <div>
        <div>
          <div class="header mt-2">
            <span class="header-icon-qrcode">
              <i class="fas fa-qrcode"></i>
            </span>
            <span class="qrcode-title"
              >{{ $t('newAction.stepThree.generatedQRCodes') }}
            </span>
          </div>
          <p style="margin-top: 10px;">
            <span>{{
              $t('newAction.stepThree.descriptionGeneratedQrCodes')
            }}</span>
          </p>
        </div>
        <div>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(qrcodeUrl)="row">
              <button
                class="btn btn-primary"
                style="margin-left: 20px;"
                @click="downloadQrCode(row.item.qrcodeUrl, row.item.id)"
              >
                <i class="fas fa-qrcode"></i>
              </button>
              <span class="copy-div">
                <i
                  style="margin-left: 20px; cursor: pointer;"
                  :title="`${$t('resend.copyLink')}`"
                  @click="copiarUrlQrCode(row.item.qrcodeUrl)"
                  class="fas fa-link copy"
                ></i>
              </span>
            </template>
            <template v-slot:cell(options)="row">
              <button
                class="btn btn-outline-danger"
                @click="removeQrcode(row.item.id)"
                :title="$t('newAction.stepThree.deleteQrcode')"
              >
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
            </template>
          </b-table>
          <div class="mt-4 mb-4 footer-buttons-area">
            <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              aria-controls="table-items"
            ></b-pagination>
          </div>
          <div class="col-12 footer-buttons-area">
            <button @click="$router.back()" class="btn btn-info">
              {{ $t('genericMessages.goBack') }}
            </button>
            <button @click="saveChanges" class="btn btn-info close-btn">
              {{ $t('newAction.stepOne.saveChanges') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import vueStep from 'vue-step';
import swal from 'sweetalert';
import api from '../../../../services/api';

const QRCode = require('qrcode');

export default {
  components: { vueStep },

  data: () => ({
    items: [],
    fields: [],
    perPage: 10,
    currentPage: 1,
  }),

  computed: {
    ...mapFields('actions', ['action']),
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`/action/${this.$route.params.id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    this.action = { ...response.data };

    await this.getQrcodes();
  },

  methods: {
    copiarUrlQrCode(url) {
      const urlInput = document.createElement('input');
      document.body.appendChild(urlInput);
      urlInput.value = url;
      urlInput.select();
      document.execCommand('copy');
      document.body.removeChild(urlInput);

      this.$bvToast.toast(
        'O link do QR Code foi copiado para a área de transferência.',
        {
          title: this.$t('resend.messages.copyUrl.title'),
          autoHideDelay: 3000,
          variant: 'success',
          solid: true,
        },
      );
    },

    downloadQrCode(qrcodeUrl, id) {
      QRCode.toDataURL(
        qrcodeUrl,
        { width: 500, height: 500 },
        function download(err, url) {
          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `QRcode-${id}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        },
      );
    },

    saveChanges() {
      swal({
        title: this.$t('newAction.stepThree.savedQrCodes'),
        text: this.$t('newAction.stepThree.wish'),
        icon: 'success',
        buttons: {
          leave: {
            text: this.$t('newAction.stepThree.cancel'),
            value: 'cancel',
          },
          next: {
            text: this.$t('newAction.stepThree.backListActions'),
            value: 'skip',
          },
        },
      }).then((value) => {
        if (value === 'skip') {
          this.$router.push('/action-list');
        }
      });
    },

    async getQrcodes() {
      const response = await api.get(`/qrcodes/${this.action._id}`, {
        headers: { 'x-access-token': this.userAuth.token },
      });

      if (response.data) {
        this.fields = response.data.columns;
        this.items = response.data.indicators;
      }

      this.fields.unshift({ label: 'QR Code ID', key: 'qrcodeId' });

      this.fields.push(
        { label: 'Download QR Code', key: 'qrcodeUrl' },
        {
          label: this.$t('newAction.stepThree.qrcodeTableOptions'),
          key: 'options',
        },
      );
    },

    async removeQrcode(id) {
      swal({
        title: this.$t('newAction.stepThree.deleteQrcode'),
        text: this.$t('newAction.stepThree.deleteQrcodeDescription'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await api.delete(`/qrcode/${this.action._id}/${id}`, {
            headers: { 'x-access-token': this.userAuth.token },
          });

          await this.getQrcodes();
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ellipsis {
  color: #c1c1c1;
}

.copy-div {
  color: #4ce595;
  font-size: 18px;
}

.ellipsis:hover {
  cursor: all-scroll;
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

td,
th {
  text-align: center;
}

td:first-child,
th:first-child {
  text-align: left;
}

.footer-buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .close-btn {
    max-height: 40px;
  }
}

.qrcode-title {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: #bdbdbd;
}

.header {
  display: flex;
  flex-direction: row;

  .header-icon-qrcode {
    float: left;
    font-size: 12px;
    margin-top: 8px;
    padding-right: 12px;
    color: #bdbdbd;
  }
}

.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 8px 24px;
  border-radius: 4px;
  margin: 8px;
}

.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

button {
  &:hover {
    color: $white;
  }
}

.indicator-th {
  position: relative;
}

.indicator-info-icon {
  margin-left: 5px;
  position: absolute;
  top: 12px;
}

.main-qrcode {
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/generate-all-qr-code/index.vue